import script from "./TypeSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./TypeSelector.vue?vue&type=script&setup=true&lang=js"

import "./TypeSelector.vue?vue&type=style&index=0&id=42c31204&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42c31204"]])

export default __exports__